<template>
  <div class="top-bar">
    <div class="brand">
      <template v-if="$route.name !== 'start'">
        <router-link :to="{ name: 'projects.index' }">
          <strong>ระบบขออนุมัติและจัดการกิจกรรม</strong> <span class="d-none d-xl-inline"> สำนักงานกิจการนักศึกษาและศิษย์เก่าสัมพันธ์ สจล.</span>
        </router-link>
      </template>
      <template v-else>
        <strong>ระบบขออนุมัติและจัดการกิจกรรม</strong> <span class="d-none d-xl-inline"> สำนักงานกิจการนักศึกษาและศิษย์เก่าสัมพันธ์ สจล.</span>
      </template>
    </div>
    <div class="menu">
      <b-dropdown
        toggle-tag="a"
        size="sm"
        right
        class="current-user"
        menu-class="user-menu"
        variant="light"
      >
        <template slot="button-content">
          <font-awesome-icon
            icon="user-circle"
            class="user-icon mr-0 mr-lg-2"
          />
          <span class="display-name d-none d-lg-inline">{{ $auth.user().thFullName }}</span>
          <span class="role d-none d-lg-inline">(<span>ระดับ: </span>{{ $auth.user().roleText }})</span>
        </template>
        <b-dropdown-item href="/e-filing/manual/src" target="_blank">
          <font-awesome-icon icon="book" />
          คู่มือการใช้งาน
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item v-b-modal.edit-profile-modal href="#">
          <font-awesome-icon icon="pencil-alt" />
          แก้ไขข้อมูลส่วนตัว
        </b-dropdown-item>
        <b-dropdown-item v-if="$auth.user().role !== 'osda'" :to="{ name: 'start' }">
          <font-awesome-icon icon="sync" />
          สลับสิทธิ์การใช้งาน
        </b-dropdown-item>
        <b-dropdown-divider />
        <b-dropdown-item href="#" @click.prevent="logout">
          <font-awesome-icon icon="sign-out-alt" />
          ออกจากระบบ
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <edit-profile-modal />
  </div>
</template>

<script>
import EditProfileModal from '@/components/EditProfileModal'

export default {
  components: {
    EditProfileModal
  },
  methods: {
    logout () {
      this.$auth.logout()
      this.$router.push({ name: 'login' })
      alert('ออกจากระบบสำเร็จ')
    }
  }
}
</script>

<style scoped lang="scss">
  $background-color: $brand-color;

  .top-bar {
    padding: 8px 20px 9px 20px;
    background: rgb(251,131,50);
    background: linear-gradient(90deg, rgba(251,131,50,1) 0%, rgba(251,131,50,1) 25%, rgba(208,85,54,1) 100%);
    display: flex;
    color: $white;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 5;
  }

  .brand {
    font-size: $font-size-lg * 0.9;
  }

  .menu {
    margin-left: auto;
    font-size: $font-size-sm;
  }

  .current-user {
    .display-name {
      margin-right: 4px;
    }
  }
</style>

<style lang="scss">
  .top-bar {
    .brand {
      a {
      color: unset;

      &:hover {
        color: unset;
        opacity: 0.85;
        text-decoration: none;
      }
    }
    }

    .menu {
      .current-user {
        .user-menu {
          font-size: $font-size-sm;
          padding-top: 5px;
          padding-bottom: 5px;

          .dropdown-item {
            padding-left: 15px;
            padding-right: 15px;
          }

          .dropdown-divider {
              margin: 5px 0;
            }
        }
      }
    }
  }
</style>
